import React from "react";
import { motion } from "framer-motion";
import { Coffee, Sprout, Flame, Truck } from "lucide-react";
import Reveal from "@/components/Reveal";
import { Eyes } from "@/components/BrandMark";
import { useLang } from "@/i18n";

const ICONS = [Coffee, Sprout, Flame, Truck];

const RitualOrigin = () => {
  const { t } = useLang();
  const r = t.ritual;

  return (
    <section id="ritual" className="bg-[#E6D9B6] py-24 md:py-32 px-6 md:px-12 lg:px-20 scroll-mt-20">
      <div className="max-w-7xl mx-auto grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
        <div>
          <Reveal>
            <div className="flex items-center gap-3 mb-6">
              <Eyes size={13} color="#3B2523" gap={11} blink />
              <p className="text-[#3B2523]/70 uppercase tracking-[0.25em] text-xs font-semibold">{r.tag}</p>
            </div>
          </Reveal>
          <Reveal delay={0.05}>
            <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight text-[#3B2523] leading-[1.03]">
              {r.title}
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="text-[#3B2523]/80 text-lg mt-7 leading-relaxed max-w-lg">{r.text}</p>
          </Reveal>
        </div>

        <div className="grid sm:grid-cols-2 gap-4">
          {r.items.map((item, i) => {
            const Icon = ICONS[i];
            return (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: i * 0.08 }}
                className="bg-[#F5F1E8] rounded-2xl p-7 border border-[#3B2523]/10"
              >
                <div className="w-12 h-12 rounded-xl bg-[#3B2523] flex items-center justify-center">
                  <Icon size={22} className="text-[#F4D35E]" strokeWidth={1.7} />
                </div>
                <h3 className="font-display text-lg font-bold text-[#3B2523] mt-5">{item.t}</h3>
                <p className="text-[#3B2523]/70 text-sm mt-2 leading-relaxed">{item.d}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default RitualOrigin;
